import React from 'react';
import { Box, useTheme } from '@mui/material';

const BackgroundAtmosphere = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const strokeColor = isDark ? 'rgba(229, 169, 60, 0.08)' : 'rgba(138, 92, 54, 0.08)';
  const highlightColor = isDark ? 'rgba(56, 189, 248, 0.12)' : 'rgba(2, 132, 199, 0.12)';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        zIndex: 0,
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      {/* Top-Right Astrolabe / Celestial Coordinates Scheme */}
      <Box
        className="ambient-float"
        sx={{
          position: 'absolute',
          top: -120,
          right: -120,
          width: { xs: 340, md: 540 },
          height: { xs: 340, md: 540 },
          opacity: 0.85,
        }}
      >
        <svg viewBox="0 0 400 400" width="100%" height="100%" fill="none">
          {/* Outer Astrolabe Rings */}
          <circle cx="200" cy="200" r="190" stroke={strokeColor} strokeWidth="1.5" />
          <circle cx="200" cy="200" r="180" stroke={strokeColor} strokeWidth="0.8" strokeDasharray="3 3" />
          <circle cx="200" cy="200" r="150" stroke={strokeColor} strokeWidth="1" />
          <circle cx="200" cy="200" r="110" stroke={highlightColor} strokeWidth="1.2" />
          <circle cx="200" cy="200" r="70" stroke={strokeColor} strokeWidth="0.8" strokeDasharray="4 2" />
          <circle cx="200" cy="200" r="30" stroke={strokeColor} strokeWidth="1" />

          {/* Coordinate Axes & Radians */}
          <line x1="10" y1="200" x2="390" y2="200" stroke={strokeColor} strokeWidth="0.8" />
          <line x1="200" y1="10" x2="200" y2="390" stroke={strokeColor} strokeWidth="0.8" />
          <line x1="65" y1="65" x2="335" y2="335" stroke={strokeColor} strokeWidth="0.6" strokeDasharray="2 4" />
          <line x1="65" y1="335" x2="335" y2="65" stroke={strokeColor} strokeWidth="0.6" strokeDasharray="2 4" />

          {/* Inscribed Golden Polygons / Engineering Triangles */}
          <polygon points="200,50 330,275 70,275" stroke={strokeColor} strokeWidth="0.8" />
          <polygon points="200,350 70,125 330,125" stroke={strokeColor} strokeWidth="0.6" strokeDasharray="4 4" />

          {/* Micro Measurement Ticks */}
          <circle cx="200" cy="200" r="185" stroke={strokeColor} strokeWidth="2" strokeDasharray="1 12" />
        </svg>
      </Box>

      {/* Bottom-Left Leonardo da Vinci Spiral & Circuit Schematic */}
      <Box
        className="ambient-float"
        sx={{
          position: 'absolute',
          bottom: -100,
          left: -100,
          width: { xs: 300, md: 460 },
          height: { xs: 300, md: 460 },
          opacity: 0.75,
          animationDelay: '-7s',
        }}
      >
        <svg viewBox="0 0 400 400" width="100%" height="100%" fill="none">
          {/* Concentric Harmonic Arcs */}
          <circle cx="200" cy="200" r="170" stroke={strokeColor} strokeWidth="1" />
          <circle cx="200" cy="200" r="130" stroke={strokeColor} strokeWidth="0.8" strokeDasharray="4 4" />
          <circle cx="200" cy="200" r="90" stroke={highlightColor} strokeWidth="1" />
          <circle cx="200" cy="200" r="50" stroke={strokeColor} strokeWidth="0.8" />

          {/* Technical Circuit Bus / Grid Vectors */}
          <path d="M 50,200 L 150,200 L 180,170 L 350,170" stroke={strokeColor} strokeWidth="1" />
          <path d="M 50,230 L 170,230 L 200,260 L 350,260" stroke={strokeColor} strokeWidth="0.8" strokeDasharray="3 3" />
          <circle cx="180" cy="170" r="3" fill={strokeColor} />
          <circle cx="200" cy="260" r="3" fill={strokeColor} />
          <circle cx="150" cy="200" r="2" fill={strokeColor} />
        </svg>
      </Box>
    </Box>
  );
};

export default BackgroundAtmosphere;
